export const groupByCates = ['terms']; // 关闭 'filters' 'histgram'
export const groupByCatesMap = {
  // filters: '根据查询条件分组',
  terms: '根据指定 field 分组',
};
